"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography } from "@mantine/core";
import { useRouter } from "next/navigation";
export default function PureHtml(t0) {
  const $ = _c(9);
  const {
    html
  } = t0;
  const router = useRouter();
  if (!html) {
    return null;
  }
  let t1;
  if ($[0] !== router) {
    t1 = e => {
      const link = e.target.closest("a");
      if (!link) {
        return;
      }
      const href = link.getAttribute("href");
      if (href && href.startsWith("/") && !href.startsWith("//")) {
        e.preventDefault();
        router.push(href);
      }
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  let t2;
  if ($[2] !== html) {
    t2 = html ? html.replace(/<p><br\s*\/?><\/p>/gi, "") : "";
    $[2] = html;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      __html: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleClick || $[7] !== t3) {
    t4 = <Typography mb="xs"><div onClick={handleClick} className="text-body" dangerouslySetInnerHTML={t3} /></Typography>;
    $[6] = handleClick;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}